var _style, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.spinner_nOfF{animation:spinner_qtyZ 2s cubic-bezier(0.36,.6,.31,1) infinite}\n\t\t.spinner_fVhf{animation-delay:-.5s}\n\t\t.spinner_piVe{animation-delay:-1s}\n\t\t.spinner_MSNs{animation-delay:-1.5s}\n\t\t@keyframes spinner_qtyZ{\n\t\t\t0%{r:0}\n\t\t\t25%{r:6px;cx:8px}\n\t\t\t50%{r:6px;cx:24px}\n\t\t\t75%{r:6px;cx:40px}\n\t\t\t100%{r:0;cx:40px}\n\t\t}\n\t\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_nOfF",
    cx: 8,
    cy: 24,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_nOfF spinner_fVhf",
    cx: 8,
    cy: 24,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_nOfF spinner_piVe",
    cx: 8,
    cy: 24,
    r: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_nOfF spinner_MSNs",
    cx: 8,
    cy: 24,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.a7170dd6e799d341ff405c0c09c518eb.svg";
export { ForwardRef as ReactComponent };